// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #007bff;
  color: white;
  padding: 1rem 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.navbar-brand {
  font-size: 1.5rem;
  font-weight: bold;
}

.navbar-brand a {
  color: white;
  text-decoration: none;
}

/* Style pour la partie 'Link' du nom */
.navbar-brand-link {
  color: orange; /* Ou une autre nuance d'orange si vous préférez */
}

.navbar-menu {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

.navbar-item {
  margin-left: 1.5rem;
}

.navbar-item a {
  color: white;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.navbar-item a:hover {
  color: #f0f0f0;
}

/* Style pour le lien de navigation actif */
.navbar-item a.active {
  color: orange; /* Utiliser la même couleur que pour 'Link' */
  font-weight: bold; /* Optionnel: rendre le texte en gras */
}

/* Styles pour l'authentification */
.navbar-auth {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.navbar-username {
  font-weight: 500;
  margin-right: 0.5rem;
}

.btn-logout {
  background-color: transparent;
  border: 1px solid white;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.btn-logout:hover {
  background-color: white;
  color: #007bff;
}

.btn-login, .btn-register {
  color: white;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.btn-login {
  border: 1px solid white;
}

.btn-register {
  background-color: white;
  color: #007bff;
}

.btn-login:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.btn-register:hover {
  background-color: #f0f0f0;
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    padding: 1rem;
  }

  .navbar-brand {
    margin-bottom: 1rem;
  }

  .navbar-menu {
    flex-direction: column;
    width: 100%;
    margin-bottom: 1rem;
  }

  .navbar-item {
    margin: 0.5rem 0;
    margin-left: 0;
    text-align: center;
  }

  .navbar-auth {
    flex-direction: column;
    width: 100%;
    gap: 0.5rem;
  }

  .btn-login, .btn-register, .btn-logout {
    width: 100%;
    text-align: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,uCAAuC;AACvC;EACE,aAAa,EAAE,kDAAkD;AACnE;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,aAAa,EAAE,6CAA6C;EAC5D,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;AACF","sourcesContent":[".navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #007bff;\n  color: white;\n  padding: 1rem 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.navbar-brand {\n  font-size: 1.5rem;\n  font-weight: bold;\n}\n\n.navbar-brand a {\n  color: white;\n  text-decoration: none;\n}\n\n/* Style pour la partie 'Link' du nom */\n.navbar-brand-link {\n  color: orange; /* Ou une autre nuance d'orange si vous préférez */\n}\n\n.navbar-menu {\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.navbar-item {\n  margin-left: 1.5rem;\n}\n\n.navbar-item a {\n  color: white;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.3s ease;\n}\n\n.navbar-item a:hover {\n  color: #f0f0f0;\n}\n\n/* Style pour le lien de navigation actif */\n.navbar-item a.active {\n  color: orange; /* Utiliser la même couleur que pour 'Link' */\n  font-weight: bold; /* Optionnel: rendre le texte en gras */\n}\n\n/* Styles pour l'authentification */\n.navbar-auth {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.navbar-username {\n  font-weight: 500;\n  margin-right: 0.5rem;\n}\n\n.btn-logout {\n  background-color: transparent;\n  border: 1px solid white;\n  color: white;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n}\n\n.btn-logout:hover {\n  background-color: white;\n  color: #007bff;\n}\n\n.btn-login, .btn-register {\n  color: white;\n  text-decoration: none;\n  padding: 0.5rem 1rem;\n  border-radius: 4px;\n  font-size: 0.875rem;\n  transition: all 0.3s ease;\n}\n\n.btn-login {\n  border: 1px solid white;\n}\n\n.btn-register {\n  background-color: white;\n  color: #007bff;\n}\n\n.btn-login:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.btn-register:hover {\n  background-color: #f0f0f0;\n}\n\n@media (max-width: 768px) {\n  .navbar {\n    flex-direction: column;\n    padding: 1rem;\n  }\n\n  .navbar-brand {\n    margin-bottom: 1rem;\n  }\n\n  .navbar-menu {\n    flex-direction: column;\n    width: 100%;\n    margin-bottom: 1rem;\n  }\n\n  .navbar-item {\n    margin: 0.5rem 0;\n    margin-left: 0;\n    text-align: center;\n  }\n\n  .navbar-auth {\n    flex-direction: column;\n    width: 100%;\n    gap: 0.5rem;\n  }\n\n  .btn-login, .btn-register, .btn-logout {\n    width: 100%;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
